<section class="programSection">
    <h2 [innerHTML]="programSection?.heading"></h2>
    <p [innerHTML]="programSection?.subHeading"></p>
  <p *ngIf="!userEnrolled && !csp.eanbleDownloadButton()" class="displayMsg" [innerHTML]="programSection?.mobileText | safeHtml"></p>
    <div class="tileSection">
        <div *ngFor="let tile of tileArray" class="vertical-spacer">
            <img [src]="csp.imagePrefix() + tile?.iconPath" [alt]="tile?.adaText" role="presentation">
            <h3 [innerHTML]="tile?.title"></h3>
            <p [innerHTML]="tile?.text"></p>
        </div>
    </div>
    <app-citi-shop-add-to-browser-button
        *ngIf="!userEnrolled && csp.eanbleDownloadButton()"
        [sectionName]="programSection?.heading"
        class="hidebutton"
        (buttonClicked)="buttonClicked($event)">
    </app-citi-shop-add-to-browser-button>
</section>
